import axios from '@/axios'
import Vue from 'vue'

const state = {
  polls: [],
};

const actions = {
  fetchPolls({ commit }, config) {
    return axios.get('polls', config)
      .then((r) => {
        if (r.data.success) {
          commit('SAVE_POLLS', r.data.quizzes)
        } else {
          throw new Error("Polls forbidden");
        }
      })
  }
};

const mutations = {
  SAVE_POLLS(state, messages) {
    Vue.set(state, 'polls', messages);
  },
};

export default {
  state,
  actions,
  mutations
}
